import "./../assets/card.scss";

import { getAppealPreview } from "@teams/cards";
import { TeamsApplicationTypes, TeamsSurveyDraft, TeamsUser } from "@teams/types";
import { useCallback, useEffect, useState } from "react";

import { ReactHTMLElement } from "../../../../../_shared/components/ReactHTMLElement";
import { useButton, useDefaultResponseValues, useTheme } from "../hooks";

type Props = {
  draft: TeamsSurveyDraft;
  owner: TeamsUser;
  applicationType: TeamsApplicationTypes;
  tenantId: string;
};

export const PollPreview: React.FC<Props> = props => {
  const { owner, applicationType, tenantId } = props;

  const generateCardHtml = useCallback(() => {
    // making a copy of draft before passing to getAppealPreview because getAppealPreview has side-effects which modify the original draft
    const draft: TeamsSurveyDraft = {
      ...props.draft,
      questions: props.draft.questions.map(q => ({ ...q })),
    };

    const card = getAppealPreview(draft, owner, tenantId, applicationType);

    const html = card.render()!;

    return html;
  }, [props.draft, owner, tenantId, applicationType]);

  const [cardHtml, setCardHtml] = useState<HTMLElement>(() => generateCardHtml());
  useTheme(cardHtml);
  useDefaultResponseValues(cardHtml);

  useEffect(() => {
    setCardHtml(generateCardHtml());
  }, [generateCardHtml]);

  const { removeClickHandler, attachClickHandler, buttonLabels } = useButton(cardHtml);

  useEffect(() => {
    attachClickHandler(buttonLabels.SubmitVoteButtonLabel, () => {
      setCardHtml(generateCardHtml());
    });

    attachClickHandler(buttonLabels.SubmitResponseButtonLabel, () => {
      setCardHtml(generateCardHtml());
    });
  }, [
    attachClickHandler,
    buttonLabels.SubmitResponseButtonLabel,
    buttonLabels.SubmitVoteButtonLabel,
    generateCardHtml,
  ]);

  useEffect(() => {
    removeClickHandler(buttonLabels.AddChoiceButtonLabel);
    removeClickHandler(buttonLabels.AddCommentButtonLabel);
  }, [buttonLabels.AddChoiceButtonLabel, buttonLabels.AddCommentButtonLabel, removeClickHandler]);

  return (
    <div className="card">
      <ReactHTMLElement html={cardHtml} />
    </div>
  );
};
